import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  warningBox: {
    backgroundColor: theme.palette.lightPastelYellow,
    padding: theme.spacing(1),
    borderRadius: 8,
  },
}))

export default styles
